import { render, staticRenderFns } from "./AlbumPage.vue?vue&type=template&id=0a286802&scoped=true&"
import script from "./AlbumPage.vue?vue&type=script&lang=js&"
export * from "./AlbumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a286802",
  null
  
)

export default component.exports